import React from 'react';
import { createPortal } from 'react-dom';
import { useToastStore } from '@/store/toastStore';
import Toast from './Toast';

const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToastStore();

  return createPortal(
    <div role="status" aria-live="polite" aria-relevant="additions text" className="fixed inset-0 z-[100] pointer-events-none">
      <div className="flex flex-col items-end justify-start min-h-screen pt-4 px-4 pb-6 sm:p-6">
        <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
          {toasts.map((toast) => (
            <Toast
              key={toast.id}
              {...toast}
              onClose={removeToast}
            />
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ToastContainer;
